import React from 'react'
import { Button, Flex, Flexed, Input, Label, PhoneNumber, Selectbox } from '../../utilities/Shared'
import { useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'

const EditContact = ({onCancel,customer,setReset,reset,customerid}) => {

    const[ newinfo, setNewinfo] = useState(customer)
   
   
    const slip = async(info,id) => {

        console.log(info)
        const config = {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin':'*' 
            }
          };   
          

          const tr = {
            company:customer.compnay_id || "",
            name:info?.name || "",
            title:info?.title || "",
            email:info?.email || "",
            officephone:info?.officephone || "", 
            ext:info?.ext || "",
            cell:info?.cell || "",
            invoices:info?.invoices || "",
            
      } 
      if(newinfo.old){tr.old = newinfo.old}else{tr.old=null}
      if(newinfo.contactid){tr.contactid = newinfo.contactid}else{tr.contactid=null}
      console.log(tr)
  axios.post(`https://highgroundsoftware.com/dash/dashboard/php/updatecontact.php`,tr,config)
    .then(res => {console.log(res.data);toast.success('Saved');setReset(!reset);onCancel()})
  .catch(err => toast.error(err))
    }

    const editNewContact = async(e) => {
e.preventDefault()
const y = {
    info:newinfo
}
        await axios.post(`https://highgroundapi.herokuapp.com/customers/update/contact`,y)
        .then(res => {slip(newinfo,newinfo.contactid)})
        .catch(err  => console.log(err))
    }


    const deletecontact = async(contactid) => {
const t = {
  "id":customerid,
  "contactid":contactid
}

await axios.post(`https://highgroundapi.herokuapp.com/customers/delete/customer`,t)
.then(res => {toast.success("Contact Removed");setReset(!reset);onCancel()})
.catch(err  => console.log(err))
    }
    console.log(newinfo)
  return (

    <form onSubmit={e => editNewContact(e)}>
    <Flexed gap="20px">
        <Flex><Label> Name</Label><Input type="text" value={newinfo?.name} onChange={e => setNewinfo({...newinfo,name:e.target.value})} required/></Flex>
        
        <Flex><Label>Title</Label><Input type="text" value={newinfo?.title} onChange={e => setNewinfo({...newinfo,title:e.target.value})}/></Flex>
        <Flex><Label>Email</Label><Input type="email" value={newinfo?.email} onChange={e => setNewinfo({...newinfo,email:e.target.value})}/></Flex>
    </Flexed>
        <Flexed gap="20px" alignItems="flex-end">
        <Flex><Label>Work Phone</Label><Input type="text" value={PhoneNumber(newinfo?.officephone)} onChange={e => setNewinfo({...newinfo,officephone:e.target.value})}/></Flex>
        <Flex flex=".3"><Label>Ext</Label><Input type="text" value={newinfo?.ext} onChange={e => setNewinfo({...newinfo,ext:e.target.value})} /></Flex>
        <Flex><Label>Mobile Phone</Label><Input type="text" value={PhoneNumber(newinfo?.cell)} onChange={e => setNewinfo({...newinfo,cell:e.target.value})}/></Flex>
        <Flex><Label>Invoices</Label><Selectbox value={newinfo?.invoices} onChange={e => setNewinfo({...newinfo,invoices:e.target.value})}><option value="No">No</option><option value="Yes">Yes</option></Selectbox></Flex>
      
        <Flex display="flex" justifyContent="flex-end" alignItems="flex-end"><Button type="button" height="30px" onClick={onCancel}>Close</Button></Flex>
        <Flex display="flex" justifyContent="flex-end" alignItems="flex-end"><Button height="30px">Edit Contact</Button></Flex>
    </Flexed>
    <Flexed padding="25px 0px 0px 0px">
    <Flex ><Button type="button" bgcolor="#ff0000" height="30px" onClick={() => deletecontact(newinfo.contactid)}>DELETE</Button></Flex>
      </Flexed>
    </form>
    
  
  )
}

export default EditContact